var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import ReferenceTraits from "./ReferenceTraits";
let CatalogMemberReferenceTraits = (_dec = primitiveTrait({
  name: "Name",
  description: "The name to use for this catalog member before the reference is loaded.",
  type: "string"
}), _dec2 = primitiveTrait({
  type: "string",
  name: "Description",
  description: "The description to use for this catalog member before the reference is loaded. Markdown and HTML may be used."
}), _dec3 = primitiveTrait({
  name: "Data Custodian",
  type: "string",
  description: "Gets or sets a description of the custodian of this data item."
}), _dec4 = primitiveTrait({
  name: "Is a Group",
  description: "Is the target of this reference expected to be a catalog group?",
  type: "boolean"
}), _dec5 = primitiveTrait({
  name: "Is a Function",
  description: "Is the target of this reference expected to be a catalog function?",
  type: "boolean"
}), _dec6 = primitiveTrait({
  name: "Is Mappable",
  description: "Is the target of this reference expected to have map items?",
  type: "boolean"
}), _dec7 = primitiveTrait({
  name: "Is Chartable",
  description: "Is the target of this reference expected to have chart items?",
  type: "boolean"
}), _class = class CatalogMemberReferenceTraits extends mixTraits(ReferenceTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "description", _descriptor2, this);
    _initializerDefineProperty(this, "dataCustodian", _descriptor3, this);
    _initializerDefineProperty(this, "isGroup", _descriptor4, this);
    _initializerDefineProperty(this, "isFunction", _descriptor5, this);
    _initializerDefineProperty(this, "isMappable", _descriptor6, this);
    _initializerDefineProperty(this, "isChartable", _descriptor7, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "description", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dataCustodian", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isGroup", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isFunction", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isMappable", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isChartable", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { CatalogMemberReferenceTraits as default };